module.exports = __webpack_public_path__ + "static/media/cancer2-ribbonWarning.45e4929a.svg";